export enum CustomerGender {
    MALE = "MALE",
    FEMALE = "FEMALE",
    OTHER = "OTHER",
}
